module.exports = __webpack_public_path__ + "img/textBg.81066d42.png";